module.exports = __webpack_public_path__ + "static/es-cc1b41b0e9485796cebb98fb04a7c10e.svg";